enum CityAddress {
  In = 'IN',
  Out = 'OUT'
}

export default CityAddress;
